import { Spin } from "antd";
import styled from "styled-components";

export const StyledLoading = styled(Spin)`
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 5 
`;
